module.exports = __webpack_public_path__ + "img/article-import-color.d0c09618.svg";